import { Layout, Menu } from "antd";
import styled from "styled-components";

import { Text } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

const { Sider } = Layout;

// Harita z-index'i sidebar'ı eziyor, bunu değiştirmeyelim.
export const SiderStyled = styled(Sider)`
    position: fixed;
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    min-height: 100vh;
    
    @media ${breakpoints.xs} {
        box-shadow: 0 6px 16px 0 rgb(0 0 0 / 8%),
        0 3px 6px -4px rgb(0 0 0 / 12%),
        0 9px 28px 8px rgb(0 0 0 / 5%);
    }
`;

export const SiderContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const LogoContainer = styled.div<{ $collapsed: boolean }>`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    margin: ${props => props.$collapsed ? "32px auto" : "32px 12px 32px 32px"};
`;

export const MenuContainer = styled.div`
    height: 100%;
    max-height: calc(100vh - 160px);
    padding: 0 12px 0 16px;
    overflow-y: scroll;
    
    .ant-menu-inline .ant-menu-item, .ant-menu-item-group-title, .ant-menu-submenu-title {
        padding-left: 16px !important;
    }

    .ant-menu-item-selected {
        color: ${props => props.theme.layouts.mainLayout.sidebar.menuItem.selectedItemColor};
        background-color: ${props => props.theme.layouts.mainLayout.sidebar.menuItem.selectedItemBgColor};

        &:hover {
            background-color:  ${props => props.theme.layouts.mainLayout.sidebar.menuItem.selectedItemBgColor} !important;
        }
    }

    .ant-menu-item-icon {
        stroke-width: 1.75px;
    }

    .ant-menu-inline-collapsed {
        padding: 4px;

        .ant-menu-submenu, .ant-menu-item-group-list {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .ant-menu-item-divider {
            padding-inline: 10px !important;
        }

        .ant-menu-submenu-title, .ant-menu-item {
            width: 40px;
            padding-inline: 0 !important;
            
            .ant-menu-item-icon {
                width: 100%;
            }
        }

        .ant-menu-submenu-title {
            .ant-menu-item-icon {
                height: 24px;
                font-size: 24px !important;
                color: ${props => props.theme.layouts.mainLayout.sidebar.menuItem.submenuIconColor};
            }
        }
    }
`;

export const StyledMenu: typeof Menu = styled(Menu)`
    background-color: ${props => props.theme.layouts.mainLayout.sidebar.menu.bgColor};
    border-inline-end-color: transparent !important;
`;

export const MenuItemTitleText = styled.span`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: ${props => props.theme.layouts.mainLayout.sidebar.menuItem.titleColor};
`;

export const VersionContainer = styled.div`
    display: flex;
    place-self: center flex-end;
    width: fit-content;
    padding: 1px;
    margin: 16px 8px 8px;
    white-space: nowrap;
    background: linear-gradient(to right, ${props => props.theme.layouts.mainLayout.sidebar.versionText.startColor},
        ${props => props.theme.layouts.mainLayout.sidebar.versionText.endColor});
    border-radius: 12px;
`;

export const VersionContainerInner = styled.div`
    display: flex;
    flex: 1;
    padding: 4px 8px;
    background: ${props => props.theme.layouts.mainLayout.sidebar.versionText.bgColor};
    border-radius: 11px;
`;

export const VersionText = styled(Text)`
    width: 100%;
    text-align: center;
    background: linear-gradient(to right, 
                                ${props => props.theme.layouts.mainLayout.sidebar.versionText.startColor},
                                ${props => props.theme.layouts.mainLayout.sidebar.versionText.endColor});
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;
